import React, {FC} from 'react';

import {ApiSendOptions} from '../../../../../../../../../../src/services/http/http';
import {Trans} from '../../../../../../../../../shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../../../../../shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../../../shared/ui/src/components/buttons/buttonConstants';
import {useContactsManagerContext} from '../../../../contactsManagerContext';
import {
  buildContactsManagerEditCardGroupsEvent,
  ContactsManagerEditCardGroupsTrackingActionsEnum,
} from '../../../../helpers/trackingHelpers';

/*
 * Props.
 */

interface ContactsTableMultiRemoveFromListActionProps {
  cardIds: ReadonlyArray<number>;
  cardGroupId: number;
  onRemoveCardsFromCardGroupsAsync: (
    groupId: number,
    cardIds: ReadonlyArray<number>,
    options?: ApiSendOptions,
  ) => Promise<void>;
  onRemoveSuccess: HandlerOf<ReadonlyArray<number>>;
}

/*
 * Component.
 */

export const ContactsTableMultiRemoveFromListAction: FC<ContactsTableMultiRemoveFromListActionProps> = (
  props,
) => {
  const {cardIds, cardGroupId, onRemoveCardsFromCardGroupsAsync, onRemoveSuccess} = props;

  const {onTrackHandler} = useContactsManagerContext();
  const onRemoveClickAsync = async () => {
    try {
      await onRemoveCardsFromCardGroupsAsync(cardGroupId, cardIds);
      onRemoveSuccess(cardIds);
      onTrackHandler(
        buildContactsManagerEditCardGroupsEvent(
          ContactsManagerEditCardGroupsTrackingActionsEnum.REMOVE,
          cardIds.length,
        ),
      );
    } catch {
      // TODO: Show a failed banner.
    }
  };

  return (
    <Button variant={ButtonVariantsEnum.SECONDARY} onClick={onRemoveClickAsync}>
      <Trans id="contact-manager-contacts-table-multi-select-actions-remove-from-list">
        Remove from this list
      </Trans>
    </Button>
  );
};
